import { render } from "./disposal.vue?vue&type=template&id=08016a02&scoped=true"
import script from "./disposal.vue?vue&type=script&lang=js"
export * from "./disposal.vue?vue&type=script&lang=js"

import "./disposal.vue?vue&type=style&index=0&id=08016a02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08016a02"]])

export default __exports__